import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-18" data-mp="1bmvbwt4ic0p4">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-19" data-mp="1glgbqrfukid1">
        <h2 id="faq-title" className="text-center font-display text-3xl font-bold uppercase text-white sm:text-4xl" data-id="element-20" data-mp="24ahepz5wv1ax">
          Preguntas <span className="text-amber-brand" data-id="element-21" data-mp="1ujmqwqd0ntnd">frecuentes</span>
        </h2>

        <div className="mt-10 space-y-3" data-id="element-22" data-mp="1uhk4sheziknx">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-23" data-mp="2n70s50nqzbda" data-mpi={index}>
                <h3 data-id="element-24" data-mp="14vaanugwqr0s">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-white/[0.03] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-amber-brand sm:px-6" data-id="element-25" data-mp="14usdmvmf88rt">
                    <span className="font-display text-lg font-bold uppercase leading-snug text-white" data-id="element-26" data-mp="1jj53daux0vdv">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-brand transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-27" data-mp="1sl4l65dr83hv" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-28" data-mp="1y9wdunqvo5e8">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-29" data-mp="237o6xl39dxk0">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-white/65 sm:px-6" data-id="element-30" data-mp="2h5uzqmtcp7ct">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}